import React, { useState, useMemo, useEffect, useRef } from "react";
import CancelCheckIcon from "../../assets/icons/x-circle-gray.svg";
import { IoCheckmarkOutline } from "react-icons/io5";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Linkify from "react-linkify";
import { Box } from "@mui/material";
import rightArrow from "../../assets/icons/WorkflowAutomation/right_arrow.svg";
import bin from "../../assets/icons/TemplateBuilder/Bin.svg";
import plusCircle from "../../assets/icons/plusCircle.svg";
import { Dropdown } from "antd";
import AssigneeModal from "../../pages/dynamic/ASC_AssigneeModal.js";
import { motion, AnimatePresence } from "framer-motion";
import simpleRequest from "../../utils/helpers/simpleRequest";
import {
  UpdateChecklistData,
  assigneeDataLocalAPI,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams, useLocation } from "react-router-dom";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";

const Checklist = ({
  translation1,
  translation2,
  fetchAddTask,
  checklist: list,
  setChecklist: setList,
  setChangeComp,
}) => {
  const location = useLocation();
  const isMyTask = location.pathname.includes("my-task");

  const roleAccess = window.localStorage.getItem("roleid");
  const userId = window.localStorage.getItem("userid");
  const { taskIds, taskId } = useParams();
  const taskIdsFinal = taskId || taskIds;
  const dropId = 123456;

  const percent = useMemo(() => {
    let num = 0;
    let num2 = 0;
    list.map((item) => {
      item.checklistitem?.map((item2) => {
        if (item2?.ischeck) num += 1;
      });
      num2 += item?.checklistitem?.length;
    });
    return (num / num2) * 100 || 0;
  }, [list]);

  const onDragEnd = (result) => {
    if (!result.destination) return;
    if (result?.destination?.droppableId === "123456") {
      const items = Array.from(list);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);
      items.forEach((item, ind) => {
        item.indexPosition = ind;
      });
      setList(items);
    }
  };

  const createChecklist = async () => {
    const resp = await simpleRequest("/api/User/AddChecklists", "post", {
      userid: userId,
      taskid: taskIdsFinal,
      taskChecklist: [
        {
          checklisttitle: "Checklist",
          indexPosition: list?.length,
          checklistitem: [],
        },
      ],
    });
    if (resp?.status === true) {
      const newList = [...list];
      const obj = { ...resp?.data, checklistitem: [], isOpen: true };
      newList.push(obj);
      setList([...newList]);
    }
  };

  const [firstFocus, setFirstFocus] = useState(false);
  const screenSize = useScreenSize();

  return (
    <div
      className="task-modal-dependencies-new-box"
      style={{ marginTop: "2rem" }}
    >
      <div
        className={`task-modal-dependencies-box-1 frcb 
        ${screenSize === "xs" && "px-3"}`}
      >
        <p className="mb-0">{translation1}</p>
        <p
          className="mb-0"
          style={{
            cursor:
              roleAccess === process.env.REACT_APP_IS_VIEWER
                ? "default"
                : "cursor",
          }}
          onClick={() => {
            if (roleAccess === process.env.REACT_APP_IS_VIEWER) return;
            createChecklist();
            setFirstFocus(true);
          }}
        >
          {translation2}
        </p>
      </div>
      {list?.length > 0 && (
        <div className="task-modal-new-check-line-main">
          <div className="task-modal-new-check-line-box">
            <div
              className="task-modal-new-line-color"
              style={{
                backgroundColor: "#00246a",
                width: `${percent}%`,
              }}
            ></div>
          </div>
          <div
            className="frc"
            style={{ justifyContent: percent === 0 ? "start" : "end" }}
          >
            {percent > 0 ? (
              <p
                style={{ fontSize: "12px", color: "#333333" }}
                className="mb-0"
              >
                {Math.floor(percent)}%
              </p>
            ) : (
              <p
                style={{ fontSize: "12px", color: "#333333" }}
                className="text-end mb-0"
              >
                {0}%
              </p>
            )}
          </div>
        </div>
      )}
      <Box
        sx={styles.checklistMainBox}
        style={{ padding: screenSize === "xs" && "0.5rem 1rem" }}
      >
        <Box sx={styles.checklistList} className="fc">
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId={`${dropId}`} key={`droppable-${dropId}`}>
              {(provided) => (
                <Box
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  key={`droppable-div-${dropId}`}
                  sx={styles.checklistList}
                  className="fc"
                >
                  {list
                    // ?.sort((a, b) => a.indexPosition - b.indexPosition)
                    ?.map((checklist, index) => {
                      return (
                        <Draggable
                          key={`draggable-${index}`}
                          draggableId={`${index}`}
                          index={index}
                        >
                          {(provided) => (
                            <SingleChecklist
                              checklist={checklist}
                              key={index}
                              index={index}
                              list={list}
                              setList={setList}
                              fetchAddTask={fetchAddTask}
                              setChangeComp={setChangeComp}
                              roleAccess={roleAccess}
                              provided={provided}
                              firstFocus={firstFocus}
                              setFirstFocus={setFirstFocus}
                            />
                          )}
                        </Draggable>
                      );
                    })}
                </Box>
              )}
            </Droppable>
          </DragDropContext>
        </Box>
      </Box>
    </div>
  );
};

export default Checklist;

const SingleChecklist = ({
  checklist,
  index,
  list,
  setList,
  fetchAddTask,
  setChangeComp,
  roleAccess,
  provided,
  firstFocus,
  setFirstFocus,
}) => {
  const dispatch = useDispatch();
  const { taskIds, taskId } = useParams();
  const taskIdsFinal = taskId || taskIds;
  const userID = window.localStorage.getItem("userid");

  const [isEdit, setIsEdit] = useState(false);
  const [title, setTitle] = useState("");

  const handleEdit = () => {
    const newList = [...list];
    newList[index]["checklisttitle"] = title;
    setList([...newList]);
    setIsEdit(false);

    dispatch(
      UpdateChecklistData({
        userid: userID,
        taskid: taskIdsFinal,
        taskChecklist: newList,
      }),
    );
  };

  const handleCancel = () => {
    setIsEdit(false);
    setTitle("");
  };

  const handleDelete = async () => {
    const newList = [...list];
    newList.splice(index, 1);
    newList.forEach((item, inde) => (item.indexPosition = inde));
    setList([...newList]);
    await simpleRequest("/api/User/DeleteChecklist", "post", {
      checklistid: checklist.checklistid,
    });
  };

  const handleOpen = () => {
    const newList = [...list];
    if (newList[index]?.isOpen) newList[index]["isOpen"] = false;
    else newList[index]["isOpen"] = true;
    setList([...newList]);
  };

  const onDragEnd2 = (result) => {
    const { destination, source } = result;
    if (!destination) return;

    // Get the specific checklist we are updating
    const newList = [...list];
    const checklistToUpdate = { ...newList[index] }; // index is passed from SingleChecklist
    const items = Array.from(checklistToUpdate.checklistitem);

    // Reorder items
    const [removed] = items.splice(source.index, 1);
    items.splice(destination.index, 0, removed);

    // Update indexPosition
    items.forEach((item, idx) => (item.indexPosition = idx));

    // Set back updated items to the checklist
    checklistToUpdate.checklistitem = items;
    newList[index] = checklistToUpdate;

    setList(newList);

    dispatch(
      UpdateChecklistData({
        userid: userID,
        taskid: taskIdsFinal,
        taskChecklist: newList,
      }),
    );
  };

  return (
    <Box
      sx={styles.singleChecklist}
      ref={provided.innerRef}
      {...provided.draggableProps}
    >
      <Box
        sx={styles.singleChecklistFlex}
        className="frcb check-bin-hover"
        {...provided.dragHandleProps}
      >
        <Box sx={styles.singleChecklistRow1} className="frc">
          <img
            src={rightArrow}
            alt=""
            className="cursor-pointer"
            style={{
              transform: checklist?.isOpen && "rotate(90deg)",
              transitionDuration: "300ms",
              width: "10px",
            }}
            onClick={handleOpen}
          />
          {isEdit ? (
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              style={styles.checklistTitleInput}
              autoFocus={true}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleEdit();
              }}
            />
          ) : (
            <p
              className="mb-0"
              style={styles.checklistTitle}
              onClick={() => {
                setIsEdit(true);
                setTitle(checklist?.checklisttitle);
              }}
            >
              {checklist?.checklisttitle}
            </p>
          )}
        </Box>
        {isEdit ? (
          <Box sx={styles.editFlex} className="frc">
            <IoCheckmarkOutline style={styles.checkBtn} onClick={handleEdit} />
            <img
              alt=""
              src={CancelCheckIcon}
              className="cursor-pointer"
              onClick={handleCancel}
            />
          </Box>
        ) : (
          <img
            src={bin}
            alt=""
            width={16}
            height={16}
            className="cursor-pointer hover-bin"
            onClick={handleDelete}
          />
        )}
      </Box>
      <AnimatePresence>
        {checklist?.isOpen && (
          <motion.div
            initial={{ height: 0, overflow: "hidden" }}
            animate={{ height: "auto", overflow: "hidden" }}
            exit={{ height: 0, overflow: "hidden" }}
          >
            <Box style={styles.horizontalLine} />
            {/* {checklist?.checklistitem
              ?.sort((a, b) => a.indexPosition - b.indexPosition)
              ?.map((item, innerIndex) => {
                return (
                  <CheckItem
                    item={item}
                    key={innerIndex}
                    roleAccess={roleAccess}
                    innerIndex={innerIndex}
                    index={index}
                    checklist={list}
                    setChecklist={setList}
                  />
                );
              })} */}

            {/* Nested drag drop for checklist items start */}
            <DragDropContext onDragEnd={onDragEnd2}>
              <Droppable droppableId={`checklist-${index}`}>
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {checklist?.checklistitem
                      ?.sort((a, b) => a.indexPosition - b.indexPosition)
                      ?.map((item, innerIndex) => (
                        <Draggable
                          key={`item-${index}-${innerIndex}`}
                          draggableId={`item-${index}-${innerIndex}`}
                          index={innerIndex}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps} // pure div ko drag handle ke liye.
                            >
                              {/* Drag icon */}
                              <span
                                {...provided.dragHandleProps} // sirf icon se hi drag handle ke liye.
                                className="d-none"
                                style={{ cursor: "grab", marginRight: "8px" }}
                              >
                                ☰
                              </span>

                              <CheckItem
                                item={item}
                                key={innerIndex}
                                roleAccess={roleAccess}
                                innerIndex={innerIndex}
                                index={index}
                                checklist={list}
                                setChecklist={setList}
                              />
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            {/* Nested drag drop for checklist items end */}

            {checklist?.isOpen && (
              <AddItem
                fetchAddTask={fetchAddTask}
                setChangeComp={setChangeComp}
                index={index}
                checklist={list}
                setChecklist={setList}
                firstFocus={firstFocus}
                setFirstFocus={setFirstFocus}
              />
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

const AvatarWithDropdown = React.memo(
  ({
    item,
    assigneeModelOpen,
    setAssigneeModelOpen,
    assigneeData,
    setAssigneeData,
    addUsersData,
    removeUsersData,
    fetchAssignees,
  }) => {
    const assigneeMap = React.useMemo(() => {
      return Object.fromEntries(assigneeData?.map((user) => [user.id, user]));
    }, [assigneeData]);

    const mergedAssignees = item.checklistitemassignees?.map((assignee) => ({
      ...assignee,
      assigneeimage: assigneeMap[assignee.assigneeid]?.imageurl || "",
    }));
    const location = useLocation();
    const isMyTask = location.pathname.includes("my-task");

    return (
      <>
        {item.checklistitemassignees
          ?.slice(0, 3)
          ?.map((assignee, assigneeIndex) => {
            return (
              <div key={assignee.assigneeid} className="">
                {assignee?.assigneeimage ? (
                  <img
                    src={assignee.assigneeimage}
                    alt="avatar"
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      marginLeft: assigneeIndex !== 0 && "-25px",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      background: "#95a7c6",
                      border: "1px solid white",
                      fontSize: "14px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      marginLeft: assigneeIndex !== 0 && "-25px",
                    }}
                  >
                    {/* {assignee?.initials} */}
                    {assignee?.assigneeinitials ||
                      assignee?.assigneename?.slice(0, 2).toUpperCase()}
                  </div>
                )}
              </div>
            );
          })}

        {item?.checklistitemassignees?.length > 3 && (
          <div className="px-1 lengthInCircle2" style={{ marginLeft: "-28px" }}>
            +{item?.checklistitemassignees?.length - 3}
          </div>
        )}

        <Dropdown
          trigger={["click"]}
          open={assigneeModelOpen}
          onOpenChange={setAssigneeModelOpen}
          getPopupContainer={(trigger) => trigger.parentElement}
          dropdownRender={() => (
            <AssigneeModal
              sendingData={assigneeData}
              addUsersData={addUsersData}
              removeUsersData={removeUsersData}
              closeAssigneeModal={() => {
                setAssigneeModelOpen(false);
              }}
              showWorkersTab={true}
              showTeamsTab={false}
              showSelectedDisabled={true}
              fetchAssignees={fetchAssignees}
              style={{
                position: "fixed",
                top: "10rem",
                left: isMyTask ? "1%" : "unset",
                width: "500px",
                maxWidth: isMyTask ? "97%" : "450px",
              }}
            />
          )}
        >
          <img
            src={plusCircle}
            alt="add"
            width={25}
            className="pointer"
            style={{
              marginLeft: item?.checklistitemassignees?.length !== 0 && "-6px",
            }}
            onClick={() => {
              setAssigneeModelOpen(true);
              if (!item?.checklistitemassignees?.length > 0) return;
              setAssigneeData(
                item.checklistitemassignees.map((a) => ({
                  id: a.assigneeid,
                  firstName: a.assigneename,
                  type: "single",
                })),
              );
            }}
          />
        </Dropdown>
      </>
    );
  },
);

const CheckItem = ({
  item,
  roleAccess,
  innerIndex,
  index,
  checklist,
  setChecklist,
}) => {
  const dispatch = useDispatch();
  const { taskIds, taskId } = useParams();
  const taskIdsFinal = taskId || taskIds;
  const userID = window.localStorage.getItem("userid");

  const [isEdit, setIsEdit] = useState(false);
  const [checklistName, setChecklistName] = useState("");
  const linkDecorator = (decoratedHref, decoratedText, key) => (
    <a
      href={decoratedHref}
      key={key}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "blue", textDecoration: "underline" }}
    >
      {decoratedText}
    </a>
  );
  const handleEdit = () => {
    const list = [...checklist];
    list.forEach((item, i) => {
      if (i === index) {
        item.checklistitem.forEach((item2, ind) => {
          if (ind === innerIndex) item2.itemname = checklistName;
        });
      }
    });
    setChecklist([...list]);
    setIsEdit(false);

    dispatch(
      UpdateChecklistData({
        userid: userID,
        taskid: taskIdsFinal,
        taskChecklist: list,
      }),
    );
  };

  const handleCancel = () => {
    setIsEdit(false);
    setChecklistName(item.itemname);
  };

  const handleDelete = async () => {
    const list = [...checklist];
    list[index]["checklistitem"].splice(innerIndex, 1);
    setChecklist([...list]);
    if (item?.checklistitemid) {
      await simpleRequest("/api/User/DeleteChecklistItem", "post", {
        checklistitemid: item.checklistitemid,
      });
    }
  };

  const handleCheck = () => {
    const newList = [...checklist];
    newList.forEach((item, i) => {
      if (i === index) {
        item.checklistitem.forEach((item2, ind) => {
          if (ind === innerIndex) item2.ischeck = item2.ischeck ? 0 : 1;
        });
      }
    });
    setChecklist([...newList]);

    dispatch(
      UpdateChecklistData({
        userid: userID,
        taskid: taskIdsFinal,
        taskChecklist: newList,
      }),
    );
  };

  // stock assignees Data
  const [assigneeModelOpen, setAssigneeModelOpen] = useState(false);

  const [assigneeData, setAssigneeData] = useState([
    // ...LocalAssineData,
  ]);

  useEffect(() => {
    dispatch(assigneeDataLocalAPI(assigneeData, "localData_From_Checklist"));
  }, [assigneeData]);

  const dedupeAssignees = (users = []) => {
    return Array.from(
      new Map(
        users.filter((user) => user?.id).map((user) => [user.id, user]),
      ).values(),
    );
  };

  // callback fun() for data passing to child and taking data 👇.
  const addUsersData = (asc, string) => {
    let incomingAssignees = [];
    if (string === "single") {
      incomingAssignees = [asc];
    } else if (Array.isArray(asc)) {
      incomingAssignees = asc;
    }
    const newAssignees = dedupeAssignees([
      ...assigneeData,
      ...incomingAssignees,
    ]);
    setAssigneeData(newAssignees);

    const list = [...checklist];
    list[index].checklistitem[innerIndex].checklistitemassignees =
      newAssignees.map((a) => ({
        assigneeid: a.id,
        assigneename: a.firstName,
        type: "single",
      }));
    setChecklist(list);

    dispatch(
      UpdateChecklistData({
        userid: userID,
        taskid: taskIdsFinal,
        taskChecklist: list,
      }),
    );
  };

  const removeUsersData = (asc, string) => {
    let removeIds = [];
    if (string === "single") {
      removeIds = [asc?.id];
    } else if (Array.isArray(asc)) {
      removeIds = asc.map((user) => user?.id);
    }
    const newAssignees = assigneeData.filter((x) => !removeIds.includes(x.id));
    setAssigneeData(newAssignees);

    const list = [...checklist];
    list[index].checklistitem[innerIndex].checklistitemassignees =
      newAssignees.map((a) => ({
        assigneeid: a.id,
        assigneename: a.firstName,
        type: "single",
      }));
    setChecklist(list);

    dispatch(
      UpdateChecklistData({
        userid: userID,
        taskid: taskIdsFinal,
        taskChecklist: list,
      }),
    );
  };

  const [fetchAssignees, setFetchAssignees] = useState([]);

  useEffect(() => {
    const list = [...checklist];
    const checklistItem = list[index]?.checklistitem[innerIndex];

    if (checklistItem) {
      if (!checklistItem.checklistitemassignees) {
        const assignees = item?.checklistitemassignees || [];
        // const assignees = checklistItem?.checklistitemassignees || [];

        checklistItem.checklistitemassignees = assignees.map((a) => ({
          assigneeid: a.assigneeid,
        }));

        // Set assigneeData for display
        setAssigneeData(
          assignees.map((a) => ({
            id: a.assigneeid,
            firstName: a.assigneename,
            type: "single",
          })),
        );
      }

      // delete checklistItem.checklistitemassignees;
      setChecklist(list);
    }
  }, [index, innerIndex]);

  return (
    <Box className="frcb py-2 task-modal-new-dependency check-bin-hover">
      <Box className="frc" style={{ columnGap: "0.5rem", flexGrow: 1 }}>
        <AvatarWithDropdown
          item={item}
          key={item.checklistitemid}
          assigneeModelOpen={assigneeModelOpen}
          setAssigneeModelOpen={setAssigneeModelOpen}
          assigneeData={assigneeData}
          setAssigneeData={setAssigneeData}
          addUsersData={addUsersData}
          removeUsersData={removeUsersData}
          fetchAssignees={fetchAssignees}
        />
        <Box
          className="task-modal-new-check-box"
          style={{
            background:
              item.ischeck && "linear-gradient(179deg, #00246A, #95A7C6)",
            border: item.ischeck ? "none" : "0.5px solid #00000026",
            pointerEvents:
              roleAccess === process.env.REACT_APP_IS_VIEWER ? "none" : "",
            cursor:
              roleAccess === process.env.REACT_APP_IS_VIEWER
                ? "default"
                : "pointer",
          }}
          onClick={handleCheck}
        ></Box>
        {isEdit ? (
          <Box sx={styles.singleCheckItemInputBox}>
            <input
              className="task-modal-new-check-input px-2"
              value={checklistName}
              onChange={(e) => setChecklistName(e.target.value)}
              autoFocus={true}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleEdit();
              }}
            />
          </Box>
        ) : (
          <Box
            className="task-modal-new-dependency-text decoration-none px-2"
            style={{
              cursor:
                roleAccess === process.env.REACT_APP_IS_VIEWER
                  ? "default"
                  : "pointer",
              fontWeight: 400,
              opacity: item.ischeck ? 0.5 : 1,
            }}
            onClick={() => {
              setIsEdit(true);
              setChecklistName(item?.itemname);
            }}
          >
            <Linkify componentDecorator={linkDecorator}>
              {item.itemname}
            </Linkify>
          </Box>
        )}
      </Box>
      {isEdit ? (
        <Box sx={styles.editFlex} className="frc">
          <IoCheckmarkOutline style={styles.checkBtn} onClick={handleEdit} />
          <img
            alt=""
            src={CancelCheckIcon}
            className="cursor-pointer"
            onClick={handleCancel}
          />
        </Box>
      ) : (
        <img
          src={bin}
          width={16}
          height={16}
          className="cursor-pointer hover-bin"
          onClick={handleDelete}
        />
      )}
    </Box>
  );
};

const AddItem = ({
  fetchAddTask,
  setChangeComp,
  checklist,
  setChecklist,
  index,
  firstFocus,
  setFirstFocus,
}) => {
  const [checklistName, setChecklistName] = useState("");
  const [activeCheckInput, setActiveCheckInput] = useState(false);
  const dispatch = useDispatch();
  const screenSize = useScreenSize();

  const { taskIds, taskId } = useParams();
  const taskIdsFinal = taskId || taskIds;
  const userID = window.localStorage.getItem("userid");

  const addItem = () => {
    if (checklistName?.length === 0) return;
    const list = [...checklist];
    list[index]["checklistitem"].push({
      ischeck: 0,
      indexPosition: list[index]["checklistitem"].length,
      itemname: checklistName,
    });
    setChecklist([...list]);
    setChecklistName("");
    dispatch(
      UpdateChecklistData({
        // taskid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        userid: userID,
        taskid: taskIdsFinal,
        taskChecklist: list,
      }),
    );
  };

  const firstInputRef = useRef(null);
  useEffect(() => {
    if (firstInputRef.current && firstFocus === true) {
      firstInputRef.current.focus();
      setFirstFocus(false);
    }
  }, [checklist]);

  const isMobile = window.innerWidth <= 768;

  return (
    <Box
      className="frcb py-2 task-modal-new-dependency"
      style={{ borderBottom: "1px dashed #a5a5a5" }}
    >
      <Box className="frc" style={{ columnGap: "0.5rem", flexGrow: "1" }}>
        <Box
          className="task-modal-new-check-box"
          style={{
            border: "0.5px solid #00000026",
            opacity: 0,
          }}
        ></Box>
        <input
          className="task-modal-new-check-input px-2"
          placeholder={fetchAddTask[16]?.translation}
          value={checklistName}
          ref={index !== 0 ? firstInputRef : null}
          // autoFocus={!isMobile}
          onChange={(e) => {
            setChangeComp(e.target.value);
            setChecklistName(e.target.value);
          }}
          onFocus={() => setActiveCheckInput(true)}
          onKeyDown={(e) => {
            if (e.key === "Enter") addItem();
          }}
        />
      </Box>
      {activeCheckInput && (
        <Box className="frc" style={{ columnGap: "1rem", flexShrink: 0 }}>
          <IoCheckmarkOutline style={styles.checkBtn} onClick={addItem} />
          <img
            alt=""
            src={CancelCheckIcon}
            style={{ cursor: "pointer" }}
            onClick={() => {
              setChecklistName("");
              setActiveCheckInput(false);
            }}
          />
        </Box>
      )}
    </Box>
  );
};

const styles = {
  checklistMainBox: { padding: "0.5rem 2rem" },
  checklistList: { width: "100%", rowGap: "0.5rem" },
  singleChecklist: {},
  singleChecklistFlex: {},
  singleChecklistRow1: { columnGap: "1rem", flexGrow: 1 },
  checklistTitle: {
    color: "#333333",
    fontSize: "16px",
    fontWeight: 700,
    flexGrow: 1,
  },
  checklistTitleInput: {
    color: "#333333",
    fontSize: "16px",
    flexGrow: 1,
    border: "none",
    fontWeight: 500,
    padding: 0,
  },
  editFlex: { columnGap: "1rem", flexShrink: 0 },
  checkBtn: {
    color: "#00246A",
    fontSize: "1.2rem",
    cursor: "pointer",
  },
  horizontalLine: { borderBottom: "1px dashed #a5a5a5", marginTop: "0.5rem" },
  singleCheckItemInputBox: { flexGrow: 1 },
  singleCheckItemInput: { flexGrow: 1 },
};
